import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { dominioDemandaCirurgica, caminhoArquivosServidor } from '../../config/database';
import 'assets/css/resumo.css';

class Resumo extends Component {
  state = {
    paciente: {},
    atendimento: {},
    peso: null,
    convenio: null,
    carater: null,
    dataSugerida: null,
    centroCirurgico: null,
    lateralidade: null,
    indicacaoClinica: null,
    prioridade: null,
    cidPrincipal: null,
    cidsSecundarios: [],
    tipoAcomodacao: null,
    diariasPrevistas: null,
    leitoUTI: false,
    tipoAnestesia: null,
    procedimentoPrincipal: {},
    procedimentosSecundarios: [],
    caixasOPME: [],
    materiaisConsumiveis: [],
    caixasCirurgicas: [],
    hemoderivados: [],
    equipamentos: [],
    exames: [],
    documentos: null,
    redireciona: false,
    telefone: null,
    celular: null,
    email: null,
    dataInternacao: null,
    motivoAntecipacaoInternacao: null,
    motivoAvaliacaoAnestesica: null,
    avaliacaoAnestesica: false,
    profissionalResponsavel: null,
    novoPaciente: null,
    principaisSinaisSintomas: null,
    principaisResultadosProvasDiagnosticas: null,
    recursosNecessariosAtendimentoPaciente: null,
    historiaClinica: null,
    areaMedica: null,
    eOncologica: null,
  };

  alimentaStates = () => {
    const paciente = localStorage.getItem('paciente');
    const atendimento = localStorage.getItem('atendimento');
    const convenio = localStorage.getItem('convenio');
    const peso = localStorage.getItem('peso');
    const carater = localStorage.getItem('carater');
    const profissionalResponsavel = localStorage.getItem('profissionalResponsavel');
    const dataSugerida = localStorage.getItem('dataSugerida');
    const centroCirurgico = localStorage.getItem('centroCirurgico');
    const lateralidade = localStorage.getItem('lateralidade');
    const indicacaoClinica = localStorage.getItem('indicacaoClinica');
    const prioridade = localStorage.getItem('prioridade');
    const cidPrincipal = localStorage.getItem('cidPrincipal');
    const cidsSecundarios = localStorage.getItem('cidsSecundarios');
    const tipoAcomodacao = localStorage.getItem('tipoAcomodacao');
    const diariasPrevistas = localStorage.getItem('diariasPrevistas');
    const leitoUTI = localStorage.getItem('leitoUTI');
    const tipoAnestesia = localStorage.getItem('tipoAnestesia');
    const caixasOPME = localStorage.getItem('caixasOPME');
    const materiaisConsumiveis = localStorage.getItem('materiaisConsumiveis');
    const caixasCirurgicas = localStorage.getItem('caixasCirurgicas');
    const hemoderivados = localStorage.getItem('hemoderivados');
    const equipamentos = localStorage.getItem('equipamentos');
    const procedimentoPrincipal = localStorage.getItem('procedimentoPrincipal');
    const procedimentosSecundarios = localStorage.getItem('procedimentosSecundarios');
    const duracaoEstimada = localStorage.getItem('duracaoEstimada');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const exames = localStorage.getItem('exames');
    const dataInternacao = localStorage.getItem('dataInternacao');
    const motivoAntecipacaoInternacao = JSON.parse(
      localStorage.getItem('motivoAntecipacaoInternacao')
    );
    const motivoAvaliacaoAnestesica = localStorage.getItem('motivoAvaliacaoAnestesica');
    const avaliacaoAnestesica = JSON.parse(localStorage.getItem('avaliacaoAnestesica'));
    const modalidadeAtendimento = JSON.parse(localStorage.getItem('modalidadeAtendimento'));
    const novoPaciente = localStorage.getItem('novoPaciente');
    const principaisSinaisSintomas = localStorage.getItem('principaisSinaisSintomas');
    const principaisResultadosProvasDiagnosticas = localStorage.getItem(
      'principaisResultadosProvasDiagnosticas'
    );
    const recursosNecessariosAtendimentoPaciente = localStorage.getItem(
      'recursosNecessariosAtendimentoPaciente'
    );
    const historiaClinica = localStorage.getItem('historiaClinica');
    const areaMedica = localStorage.getItem('areaMedica');
    const eOncologica = localStorage.getItem('eOncologica');

    if (paciente) this.setState({ paciente: JSON.parse(paciente) });
    if (atendimento) this.setState({ atendimento: JSON.parse(atendimento) });
    if (convenio) this.setState({ convenio: JSON.parse(convenio) });
    if (peso) this.setState({ peso });
    if (carater) this.setState({ carater: JSON.parse(carater) });
    if (profissionalResponsavel)
      this.setState({ profissionalResponsavel: JSON.parse(profissionalResponsavel) });
    if (dataSugerida) this.setState({ dataSugerida });
    if (centroCirurgico) this.setState({ centroCirurgico: JSON.parse(centroCirurgico) });
    if (lateralidade) this.setState({ lateralidade });
    if (indicacaoClinica) this.setState({ indicacaoClinica });
    if (prioridade) this.setState({ prioridade: JSON.parse(prioridade) });
    if (cidPrincipal) this.setState({ cidPrincipal: JSON.parse(cidPrincipal) });
    if (cidsSecundarios) this.setState({ cidsSecundarios: JSON.parse(cidsSecundarios) });
    if (tipoAcomodacao) this.setState({ tipoAcomodacao: JSON.parse(tipoAcomodacao) });
    if (diariasPrevistas) this.setState({ diariasPrevistas });
    if (leitoUTI) this.setState({ leitoUTI: leitoUTI === 'true' });
    if (tipoAnestesia) this.setState({ tipoAnestesia: JSON.parse(tipoAnestesia) });
    if (caixasOPME) this.setState({ caixasOPME: JSON.parse(caixasOPME) });
    if (materiaisConsumiveis)
      this.setState({ materiaisConsumiveis: JSON.parse(materiaisConsumiveis) });
    if (caixasCirurgicas) this.setState({ caixasCirurgicas: JSON.parse(caixasCirurgicas) });
    if (hemoderivados) this.setState({ hemoderivados: JSON.parse(hemoderivados) });
    if (equipamentos) this.setState({ equipamentos: JSON.parse(equipamentos) });
    if (procedimentoPrincipal)
      this.setState({ procedimentoPrincipal: JSON.parse(procedimentoPrincipal) });
    if (procedimentosSecundarios)
      this.setState({ procedimentosSecundarios: JSON.parse(procedimentosSecundarios) });
    if (duracaoEstimada) this.setState({ duracaoEstimada });
    if (telefone) this.setState({ telefone });
    else this.setState({ telefone: 'Não informado' });
    if (celular) this.setState({ celular });
    else this.setState({ celular: 'Não informado' });
    if (email) this.setState({ email });
    else this.setState({ email: 'Não informado' });
    if (exames) this.setState({ exames: JSON.parse(exames) });
    if (dataInternacao) {
      const data = new Date(dataInternacao);
      data.setDate(data.getDate() + 1);
      this.setState({ dataInternacao: data.toLocaleDateString() });
    }
    if (motivoAntecipacaoInternacao) this.setState({ motivoAntecipacaoInternacao });
    if (avaliacaoAnestesica) this.setState({ avaliacaoAnestesica: avaliacaoAnestesica === true });
    if (motivoAvaliacaoAnestesica) this.setState({ motivoAvaliacaoAnestesica });
    if (modalidadeAtendimento) this.setState({ modalidadeAtendimento });
    if (novoPaciente) this.setState({ novoPaciente: JSON.parse(novoPaciente) });
    if (principaisSinaisSintomas) this.setState({ principaisSinaisSintomas });
    if (principaisResultadosProvasDiagnosticas)
      this.setState({
        principaisResultadosProvasDiagnosticas,
      });
    if (recursosNecessariosAtendimentoPaciente)
      this.setState({
        recursosNecessariosAtendimentoPaciente,
      });
    if (historiaClinica) this.setState({ historiaClinica });
    if (areaMedica) this.setState({ areaMedica: JSON.parse(areaMedica) });
    if (eOncologica) this.setState({ eOncologica: JSON.parse(eOncologica) });
  };

  componentDidMount() {
    this.alimentaStates();
    const pedidoCirurgia = JSON.parse(localStorage.getItem('pedidoCirurgia'));

    if (pedidoCirurgia === null) this.setState({ redireciona: true });
    else {
      dominioDemandaCirurgica.get(`/api/documento/${pedidoCirurgia.id}`).then(
        res => {
          this.setState({ documentos: res.data });
        },
        () => { }
      );
    }
  }

  getDataNascimentoFormatada = () => {
    if (this.state.paciente.DAT_NASCIMENTO) {
      const data = new Date(this.state.paciente.DAT_NASCIMENTO);
      data.setDate(data.getDate() + 1);
      return data.toLocaleDateString();
    }
    return null;
  };

  getDataNascimentoFormatadaNovoPaciente = data => {
    const formatedDate = new Date(data);
    formatedDate.setDate(formatedDate.getDate() + 1);
    return formatedDate.toLocaleDateString();
  };

  getDataHoraFormatada = data => {
    if (!data) return null;
    return new Date(data).toLocaleString();
  };

  getDataFormatada = data => {
    if (!data) return null;
    return new Date(data).toLocaleDateString();
  };

  getLateralidade = lateralidade => {
    if (lateralidade === 'D') return 'Direita';
    if (lateralidade === 'E') return 'Esquerda';

    return 'Não se aplica';
  };

  getSexo = cod_sexo => {
    if (!cod_sexo) return null;

    return cod_sexo === 'M' ? 'Masculino' : 'Feminino';
  };

  getSplitNomeDocumento = nome => {
    const nomeSplit = nome.split('/');
    return nomeSplit[nomeSplit.length - 1];
  };

  bodyPacientePadrao() {
    return (
      <>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Nome:</strong>
          </span>
          <span>{this.state.paciente.NOM_PESSOA}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Nascimento:</strong>
          </span>
          <span>
            {this.getDataNascimentoFormatada(this.state.paciente.DAT_NASCIMENTO) ??
              'Não possui cadastro.'}
          </span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Prontuário:</strong>
          </span>
          <span>{this.state.paciente.NRO_PRONTUARIO}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Mãe:</strong>
          </span>
          <span>{this.state.paciente.NOM_MAE ?? 'Não possui cadastro.'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Telefone:</strong>
          </span>
          <span>
            {String(localStorage.getItem('telefone')) == 'null'
              ? 'Não informado'
              : localStorage.telefone}
          </span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Celular:</strong>
          </span>
          <span>
            {String(localStorage.getItem('celular')) == 'null'
              ? 'Não informado'
              : localStorage.celular}
          </span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Sexo:</strong>
          </span>
          <span>{this.getSexo(this.state.paciente.COD_SEXO) ?? 'Não possui cadastro.'}</span>
        </div>
      </>
    );
  }

  bodyPacienteNovo() {
    return (
      <>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Nome:</strong>
          </span>
          <span>{this.state.novoPaciente.nome}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Nascimento:</strong>
          </span>
          <span>
            {this.getDataNascimentoFormatadaNovoPaciente(this.state.novoPaciente.dataNascimento) ??
              'Não informado.'}
          </span>
        </div>
        <div
          className="row-resumo"
          style={{
            borderRight: 'solid green 2px',
          }}
        >
          <span className="titulo-card">
            <strong>Novo Prontuário:</strong>
          </span>
          <span className="span-novo-prontuario">
            {this.state.novoPaciente.numeroProntuario ?? 'Não informado'}
          </span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Mãe:</strong>
          </span>
          <span>{this.state.novoPaciente.nomeMae ?? 'Não possui cadastro.'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>CPF:</strong>
          </span>
          <span>{this.state.novoPaciente.cpf ?? 'Não informado'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>CNS:</strong>
          </span>
          <span>{this.state.novoPaciente.cns ?? 'Não informado'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Telefone:</strong>
          </span>
          <span>{this.state.novoPaciente.telefone ?? 'Não informado'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Celular:</strong>
          </span>
          <span>{this.state.novoPaciente.celular ?? 'Não informado'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Email:</strong>
          </span>
          <span>{this.state.novoPaciente.email ?? 'Não informado'}</span>
        </div>
        <div className="row-resumo">
          <span className="titulo-card">
            <strong>Sexo:</strong>
          </span>
          <span>
            {this.getSexo(this.state.novoPaciente.sexo?.value ?? this.state.novoPaciente.sexo) ??
              'Não possui cadastro.'}
          </span>
        </div>
      </>
    );
  }

  render() {
    if (this.state.redireciona) {
      return <Redirect from="/admin" to="/admin/meusPedidos" />;
    }

    return (
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Resumo do pedido</h3>
          </Grid>
          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Informações Paciente </strong>
            </CardHeader>
            <CardBody>
              {this.state.novoPaciente ? this.bodyPacienteNovo() : this.bodyPacientePadrao()}
            </CardBody>
          </Card>
          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Informações Atendimento </strong>
            </CardHeader>
            <CardBody>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Data:</strong>
                </span>
                <span>
                  {this.getDataHoraFormatada(this.state.atendimento.DAT_HORA_ATENDIMENTO) ??
                    this.getDataHoraFormatada(this.state.paciente.DAT_HORA_ATENDIMENTO) ??
                    'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Nº Ficha:</strong>
                </span>
                <span>
                  {this.state.atendimento.NRO_FAA ?? this.state.paciente.NRO_FAA ?? 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Peso:</strong>
                </span>
                <span>{this.state.peso > 0 ? this.state.peso : 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Convênio:</strong>
                </span>
                <span>
                  {this.state.convenio ? `${this.state.convenio.descricao}` : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Especialidade:</strong>
                </span>
                <span>{JSON.parse(localStorage.getItem('profissional')).equipe}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>CRM:</strong>
                </span>
                <span>{JSON.parse(localStorage.getItem('profissional')).crm}</span>
              </div>
            </CardBody>
          </Card>
          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Dados Solicitação </strong>
            </CardHeader>
            <CardBody>
              <h4 className="titulo-sessao">Procedimentos</h4>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Procedimento Principal:</strong>
                </span>
                <span>
                  {this.state.procedimentoPrincipal
                    ? `${this.state.procedimentoPrincipal.descricao}`
                    : 'Não informado'}
                </span>
                <p>
                  <strong>{`Quantidade: ${this.state.procedimentoPrincipal.quantidade}`}</strong>
                </p>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Procedimentos Secundários:</strong>
                </span>
                {this.state.procedimentosSecundarios.length > 0 ? (
                  this.state.procedimentosSecundarios.map((proc, index) => {
                    return (
                      <p key={proc.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${proc.descricao}`}
                        <p>
                          <strong>{`Quantidade: ${proc.quantidade}`}</strong>
                        </p>
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Duração Estimada:</strong>
                </span>
                <span>{this.state.duracaoEstimada ?? 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Diárias previstas:</strong>
                </span>
                <span>{this.state.diariasPrevistas ?? 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Centro Cirúrgico:</strong>
                </span>
                <span>
                  {this.state.centroCirurgico
                    ? `${this.state.centroCirurgico.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Carater atendimento:</strong>
                </span>
                <span>
                  {this.state.carater ? `${this.state.carater.descricao}` : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Modalidade Cirúrgica:</strong>
                </span>
                <span>
                  {this.state.modalidadeAtendimento
                    ? `${this.state.modalidadeAtendimento.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Profissional Responsável:</strong>
                </span>
                <span>
                  {this.state.profissionalResponsavel
                    ? `${this.state.profissionalResponsavel.crm} - ${this.state.profissionalResponsavel.nome}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Lateralidade:</strong>
                </span>
                <span>{this.getLateralidade(this.state.lateralidade) ?? 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Indicação Cirúrgica:</strong>
                </span>
                <p
                  style={{
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    wordWrap: 'break-word',
                  }}
                >
                  {this.state.indicacaoClinica ?? 'Não informado'}
                </p>
              </div>
              <div
                className="row-resumo"
                style={{
                  borderRight: `solid ${this.state.prioridade ? this.state.prioridade.cor : ''
                    } 2px`,
                }}
              >
                <span className="titulo-card">
                  <strong>Prioridade:</strong>
                </span>
                <span>
                  {this.state.prioridade ? `${this.state.prioridade.descricao}` : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>CID Principal:</strong>
                </span>
                <span>
                  {this.state.cidPrincipal
                    ? `${this.state.cidPrincipal.codigo} - ${this.state.cidPrincipal.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>CIDs Secundários:</strong>
                </span>
                {this.state.cidsSecundarios.length > 0 ? (
                  this.state.cidsSecundarios.map((cid, index) => {
                    return (
                      <p key={cid.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${cid.codigo} - ${cid.descricao}`}
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>É uma cirurgia oncológica?:</strong>
                </span>
                <span>
                  {this.state.eOncologica ? this.state.eOncologica.descricao : 'Não informado'}
                </span>
              </div>

              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Principais sinais e sintomas:</strong>
                </span>
                <span>{this.state.principaisSinaisSintomas}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Principais resultados de provas diagnósticas:</strong>
                </span>
                <span>{this.state.principaisResultadosProvasDiagnosticas}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Recursos necessários para atendimento ao paciente:</strong>
                </span>
                <span>{this.state.recursosNecessariosAtendimentoPaciente}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>História Clínica:</strong>
                </span>
                <span>{this.state.historiaClinica}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Área Médica:</strong>
                </span>
                <span>{this.state.areaMedica ? `${this.state.areaMedica.descricao}` : ''}</span>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Anestesia </strong>
            </CardHeader>
            <CardBody>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Tipo:</strong>
                </span>
                <span>
                  {this.state.tipoAnestesia
                    ? `${this.state.tipoAnestesia.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Necessita Avaliação Anestésica?:</strong>
                </span>
                <span>{this.state.avaliacaoAnestesica ? 'Sim' : 'Não'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Motivo Avaliação Anestésica:</strong>
                </span>
                <p
                  style={{
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    wordWrap: 'break-word',
                  }}
                >
                  {this.state.motivoAvaliacaoAnestesica ?? 'Não informado'}
                </p>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Data da Cirurgia e Internação </strong>
            </CardHeader>
            <CardBody>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Data sugerida:</strong>
                </span>
                <span>{this.getDataHoraFormatada(this.state.dataSugerida) ?? 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Data da internação:</strong>
                </span>
                <span>{this.state.dataInternacao ?? 'Não informado'}</span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Motivo de Antecipação da Internação:</strong>
                </span>
                <span>
                  {this.state.motivoAntecipacaoInternacao
                    ? `${this.state.motivoAntecipacaoInternacao.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Acomodação:</strong>
                </span>
                <span>
                  {this.state.tipoAcomodacao
                    ? `${this.state.tipoAcomodacao.descricao}`
                    : 'Não informado'}
                </span>
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Leito UTI?:</strong>
                </span>
                <span>{this.state.leitoUTI ? 'Sim' : 'Não'}</span>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Itens Cirurgia </strong>
            </CardHeader>
            <CardBody>
              <h4 className="titulo-sessao">Itens</h4>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Caixas OPME:</strong>
                </span>
                {this.state.caixasOPME.length > 0 ? (
                  this.state.caixasOPME.map((caixa, index) => {
                    return (
                      <p key={caixa.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${caixa.descricao}  `}
                        <p>
                          <strong>{`Quantidade: ${caixa.quantidade}`}</strong>
                        </p>
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Materiais Consumíveis:</strong>
                </span>
                {this.state.materiaisConsumiveis.length > 0 ? (
                  this.state.materiaisConsumiveis.map((material, index) => {
                    return (
                      <p key={material.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${material.descricao}  `}
                        <p>
                          <strong>{`Quantidade: ${material.quantidade}`}</strong>
                        </p>
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Caixas Cirúgicas:</strong>
                </span>
                {this.state.caixasCirurgicas.length > 0 ? (
                  this.state.caixasCirurgicas.map((caixa, index) => {
                    return (
                      <p key={caixa.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${caixa.descricao}  `}
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Hemocomponentes:</strong>
                </span>
                {this.state.hemoderivados.length > 0 ? (
                  this.state.hemoderivados.map((hemoderivado, index) => {
                    return (
                      <p key={hemoderivado.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${hemoderivado.descricao}  `}
                        <p>
                          <strong>{`Quantidade: ${hemoderivado.quantidade} ${hemoderivado.unidadeMedida.descricao}`}</strong>
                        </p>
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Equipamentos:</strong>
                </span>
                {this.state.equipamentos.length > 0 ? (
                  this.state.equipamentos.map((equipamento, index) => {
                    return (
                      <p key={equipamento.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${equipamento.descricao}  `}
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
              <div className="row-resumo">
                <span className="titulo-card">
                  <strong>Exames:</strong>
                </span>
                {this.state.exames.length > 0 ? (
                  this.state.exames.map((exame, index) => {
                    return (
                      <p key={exame.id}>
                        <strong>{`${index + 1}: `}</strong>
                        {`${exame.codigo} - ${exame.descricao}  `}
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
            </CardBody>
          </Card>

          {/*<Card>
            <CardHeader color="info" id="centroMeusPedidos">
              <strong> Documentos(s) </strong>
            </CardHeader>
            <CardBody>
              <div className="row-resumo">
                {this.state.documentos ? (
                  this.state.documentos.map((documento, index) => {
                    return (
                      <p key={documento.id}>
                        <strong>{`${index + 1}: `}</strong>
                        <a
                          target="_blank"
                          href={`${caminhoArquivosServidor}/${this.getSplitNomeDocumento(
                            documento.arquivo
                          )}`}
                          rel="noreferrer"
                        >
                          {`${this.getSplitNomeDocumento(documento.arquivo)}`}
                        </a>
                      </p>
                    );
                  })
                ) : (
                  <span>Não informado</span>
                )}
              </div>
            </CardBody>
          </Card>*/}
        </Grid>
      </Container>
    );
  }
}

export default Resumo;
